export default __webpack_public_path__ + "static/media/Copy of a-token-of-security.2d856972.jpg";